import { PasswordResetRequest } from "./passwordReset-models";
import { SIMPLE_PAYMENTS_SERVICE_GW_PREFIX } from "../constants";
import { VerifyRegistrationIdResponse } from "./models";
import { createApiClientWithArgs } from "cy-fetch/lib/client";

export const verifyIdUrl = `${SIMPLE_PAYMENTS_SERVICE_GW_PREFIX}/api/v1/simple_payments/customers/verify_registration_id`;

export const verifyRegistrationIdClient = createApiClientWithArgs({
  zod: VerifyRegistrationIdResponse,
  argsFn: (args: PasswordResetRequest) => {
    return {
      url: verifyIdUrl,
      options: {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(args),
      },
    };
  },
});
